import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {BorderDirection} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/extract-border/definition"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            mappedImage: anyImageOpResult,
            blendedBorder: anyImageOpResult,
            borderDirection: BorderDirection,
        }),
    },
}
